import { useTreatments } from '@splitsoftware/splitio-react'

export const useHideBannersSplit = () => {
  const splitTreatment = useTreatments(['CE_DEMO_ACCOUNT'])
  const hideBannersForDemoAccount = splitTreatment['CE_DEMO_ACCOUNT'].treatment === 'on'
  return { shouldHideBanners: hideBannersForDemoAccount }
}
